import slideUrl from '../assets/audio/sfx/stone_door_grind.mp3';
import { mixer } from './audio-mixer.js';

let last = 0;

/** A short, soft scrape from the middle of the door's grind, cut off as a slab settles; steps that move together share one. */
export function playSlab() {
  const now = performance.now();
  if (now - last < 250) return;
  last = now;
  mixer.playSfx(slideUrl, .3, { in: .08, out: .22, start: 1, length: .55 });
}
